import { useOutletContext } from "react-router";

// Context for search state (shared between layout and list page)
export interface RegistrationLayoutContext {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  registerRefetch: (fn: () => Promise<void>) => void;
  triggerRefetch: () => Promise<void>;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

/**
 * Hook for child pages to access the registration layout context.
 * Provides access to shared state like search query and loading state.
 */
export function useRegistrationLayout() {
  return useOutletContext<RegistrationLayoutContext>();
}
